import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';

import config from './config/config';
import { BrandingProvider, useBranding } from './context/BrandingContext';
import { WebSocketProvider } from './context/WebSocket/WebSocketProvider';
import Router from './pages/router';
// import SCSS file
import './scss/index.scss';
import MetaManager from './shared-components/MetaManager/MetaManager';
import getFirstSubdomain from './shared-functions/DomiansplitFunction';

const domain = getFirstSubdomain();

/**
 * Wrapper for Stripe Elements to handle dynamic publishable keys.
 */
function StripeElementsWrapper({ children }: { children: React.ReactNode }) {
  const { brandData } = useBranding();
  let output: any;
  if (config.guestPaymentMode !== 'hyperpay') {
    const stripePromise = useMemo(() => {
      const key =
        domain && brandData?.stripePublishableKey
          ? brandData.stripePublishableKey
          : config.stripePublishableKey;
      return loadStripe(key);
    }, [brandData?.stripePublishableKey]);

    output = <Elements stripe={stripePromise}>{children}</Elements>;
  } else {
    output = children;
  }
  return output;
}

/**
 * Map App Component
 * @returns {JSX.Element} The rendered App component.
 */
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BrandingProvider>
          <StripeElementsWrapper>
            <WebSocketProvider>
              <MetaManager />
              <Router />
            </WebSocketProvider>
          </StripeElementsWrapper>
        </BrandingProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
